<template>
    <form data-ajax-form validate>
        <input type="hidden" name="action" value="login" />
        <input type="hidden" name="nonce"  :value="nonce" />

        <div data-form-msg></div>
        <fieldset>
            <legend>User Info</legend>

            <div class="inputControl">
                <label for="username">Username: </label>
                <input type="text" id="username" name="username" placeholder="Username" required />
            </div>

            <div class="inputControl">
                <label for="password">Password: </label>
                <input type="password" id="password" name="password" placeholder="Password" required />
            </div>

            <fieldset>
                <legend>Forgot Password</legend>
                <a :href="this.passResetLink"><small>Forgot Password?</small></a>
            </fieldset>
            <br />
            <fieldset>
                <legend>Recaptcha</legend>
                <div style="float:right;" class="g-recaptcha" :data-sitekey="siteKey"></div>
            </fieldset>
            
            <fieldset class="alignRight">
                <legend>Login</legend>
                <button type="submit" class="btn btn-primary btn-large" data-submit-btn>Login</button>
            </fieldset>

        </fieldset>
    </form>
</template>

<script>
import { mapState }    from 'pinia';
import { globalStore } from "../stores/global.js";
import { loginStore }  from "../stores/login.js";

export default {
    name: "LoginForm",
    components: {},
    props: {
        nonce: {
            type: String,
            required: true
        },
        siteKey: {
            type: String,
            required: true
        }
    },
    mounted() {},
    methods: {
        showPassReset(){
            const ls = loginStore();

            ls.$patch({
                isPassResetVisible: true
            })
        }
    },
    computed: {
        ...mapState(loginStore, {
            nonce: store => store.nonces.login
        }),
        ...mapState(globalStore, {
            isUserAuthenticated: store => store.isUserAuthenticated,
            siteKey: store => store.siteKey,
            passResetLink: store => store.links.passResetLink
        })
    },
};
</script>

<style>
</style>
